// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"2ed24416","828":"1a48d31b"}[chunkId] + ".chunk.js";
};